export enum NotificationSettingsTypeEnum {
  All = 'all',
  NewTracks = 'new-tracks',
  NewVideos = 'new-videos',
  NewMentions = 'new-mentions',
  NewMessages = 'new-messages',
}
